import { Container, Grid } from '@material-ui/core';
import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { DOCUMENT_TYPES } from 'constants/global';
import { EMPTY_DOCUMENT } from 'containers/data-structure';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { ContestationDoc } from 'containers/CourtManagerLegalProceedings/constants';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import {
  CONTESTATION_REQUEST_ID,
  CONTESTATION_ACT_ID,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { getContestationDocuments } from 'containers/LawyerLegalProceedingsPage/Contestation/utils';
import { isEmpty } from 'lodash';
export interface ContestationDocumentsFormProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: any;
  contestationDocs: any;
  setContestationDocs: Function;
  requestUploadContestationDocument?: Function | undefined;
  claimNumber?: string;
  contestationId?: number;
  judgementOnMerits: any;
  contestationDocsToUpdate: any;
  isLawyer?: boolean;
  handleSuccessCallback: Function;
}

const ContestationDocumentsForm: FC<ContestationDocumentsFormProps> = props => {
  const [
    contestationOppositionActDoc,
    setContestationOppositionActDoc,
  ] = useState<ContestationDoc>({
    ...EMPTY_DOCUMENT,
  });
  const [contestationRequestDoc, setContestationRequestDoc] = useState<
    ContestationDoc
  >({
    ...EMPTY_DOCUMENT,
  });

  const setContestationRequestDocument = (document: CorporealDocument) => {
    let contestationDocuments = [...props.contestationDocs];
    if (CONTESTATION_REQUEST_ID === props.documentId) {
      setContestationRequestDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      contestationDocuments.push({
        contestId: props.contestationId,
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setContestationDocs(contestationDocuments);
      props.resetUploadedDocument();
    }
  };

  const setContestationActDocument = (document: CorporealDocument) => {
    if (CONTESTATION_ACT_ID === props.documentId) {
      let contestationDocuments = [...props.contestationDocs];
      setContestationOppositionActDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      contestationDocuments.push({
        contestId: props.contestationId,
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setContestationDocs(contestationDocuments);
      props.resetUploadedDocument();
    }
  };
  const validateUpload = () => {
    props.requestUploadContestationDocument &&
      props.requestUploadContestationDocument(
        props.contestationDocs,
        props.claimNumber,
        props.judgementOnMerits.claimId,
        props.judgementOnMerits.judiciaryProcessId,
        props.judgementOnMerits.validator,
        props.contestationDocsToUpdate,
        props.judgementOnMerits.procedureType,
        props.isLawyer,
        props.handleSuccessCallback,
      );
    props.setContestationDocs([]);
  };
  return (
    <Container className="subContainer">
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <div className="upload-doc-title">
            {translate(messages.uploadRequestDocumentTitle, props)}
          </div>
          <UploadDocumentBloc
            index={0}
            docType={DOCUMENT_TYPES.CONTESTATION_REQUEST}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            setDocumentId={props.setDocumentId}
            setDocument={setContestationRequestDocument}
            document={contestationRequestDoc}
            docId={CONTESTATION_REQUEST_ID}
          />
        </Grid>
        <Grid item xs={6}>
          <div className="upload-doc-title">
            {translate(messages.uploadOppositionActDocumentTitle, props)}
          </div>
          <UploadDocumentBloc
            index={1}
            docType={DOCUMENT_TYPES.CONTESTATION_ACT}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            setDocumentId={props.setDocumentId}
            setDocument={setContestationActDocument}
            document={contestationOppositionActDoc}
            docId={CONTESTATION_ACT_ID}
          />
        </Grid>
      </Grid>

      {!isEmpty(getContestationDocuments(props.contestationDocs)) && (
        <div className="subContainer">
          <PrimaryButton
            className="validate-button"
            data-testid="validate"
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.validateButton, props)}
            disabled={
              !props.contestationDocs[0]?.url || !props.contestationDocs[1]?.url
            }
            onClick={validateUpload}
          />
          <SecondaryButton
            title={translate(messages.cancelButton, props)}
            data-testid="go-back"
            onClick={() => {}}
          />
        </div>
      )}
    </Container>
  );
};

export default injectIntl(ContestationDocumentsForm);
